import { Injectable, OnDestroy } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class BlurService implements OnDestroy {
  private intentTarget: Element | null = null;
  private intentTimer: any = null;

  private pointerDownHandler = (ev: PointerEvent) => {
    // Record the element the user actively touched/clicked
    this.intentTarget = ev.target as Element;
    // Intent expires after a short window
    clearTimeout(this.intentTimer);
    this.intentTimer = setTimeout(() => (this.intentTarget = null), 600);
  };

  private focusInHandler = (ev: FocusEvent) => {
    const el = ev.target as HTMLElement;
    if (!el) return;

    // Only care about inputs/textareas
    if (el.tagName !== "INPUT" && el.tagName !== "TEXTAREA") return;

    // Is this a PrimeNG filter input?
    // Covers MultiSelect, Dropdown, and Listbox filters (PrimeNG 13+; adjust if your version differs)
    const isPrimeFilter = el.closest(".p-multiselect-panel .p-multiselect-filter-container") || el.closest(".p-dropdown-panel .p-dropdown-filter-container") || el.closest(".p-listbox .p-listbox-filter-container");

    if (!isPrimeFilter) return;

    // Allow focus if the user intentionally interacted with this element
    const userIntent =
      this.intentTarget &&
      (el === this.intentTarget ||
        el.contains(this.intentTarget) ||
        // Sometimes click lands on nested icons within the input container
        this.intentTarget.closest(".p-multiselect-filter-container, .p-dropdown-filter-container, .p-listbox-filter-container"));

    if (userIntent) {
      // Ensure keyboard is enabled for intentional focus
      (el as HTMLInputElement).setAttribute("inputmode", "text");
      return;
    }

    // NO user intent → suppress keyboard and defocus
    const input = el as HTMLInputElement;
    input.setAttribute("inputmode", "none");
    // Blurring immediately prevents Samsung’s keyboard pop
    // Use microtask to avoid fighting the component animation
    Promise.resolve().then(() => input.blur());
  };

  private install() {
    // Global listeners on the document
    document.addEventListener("pointerdown", this.pointerDownHandler, { capture: true, passive: true });
    document.addEventListener("focusin", this.focusInHandler, { capture: true });
  }

  constructor() {
    this.install();
  }

  ngOnDestroy() {
    document.removeEventListener("pointerdown", this.pointerDownHandler, { capture: true } as any);
    document.removeEventListener("focusin", this.focusInHandler, { capture: true } as any);
    clearTimeout(this.intentTimer);
  }
}
